// 台账
import {axiosget,axiosgetExcel} from './axios';


// 流水类型列表
export const getFlowTypeStatistics = (params) => axiosget('/sys/standingBookManage/getFlowTypeStatistics', params)
// 流水类型导出
export const getFlowTypeStatisticsForExcel = (params) => axiosgetExcel('/sys/standingBookManage/getFlowTypeStatisticsForExcel',params)
// 收支统计列表
export const getRevenueAndExpenditureStatistics = (params) => axiosget('/sys/standingBookManage/getRevenueAndExpenditureStatistics', params)
// 收支统计导出
export const getRevenueAndExpenditureStatisticsForExcel = (params) => axiosgetExcel('/sys/standingBookManage/getRevenueAndExpenditureStatisticsForExcel',params)
// 教练列表
export const getCoachStatic = (params) => axiosget('/sys/standingBookManage/getCoachStatic', params)
// 教练列表导出
export const getCoachForExcel = (params) => axiosgetExcel('/sys/standingBookManage/getCoachForExcel', params)




